// extracted by mini-css-extract-plugin
export default {"wrap":"BuyingGuide_wrap__8J5Fc","row":"BuyingGuide_row__N2jx7"};